module.exports = __webpack_public_path__ + "assets/src/style/img/footer-growing-emmen.png?4fa7f13194cb750cfd903f4c3f9d38d4";